export default __webpack_public_path__ + "static/media/blog-header-bg.d319f2c0.png";